import { PaymentType } from '@core/types/payment.type';

export namespace PaymentTypeActions {
  export class Set {
    static readonly type = '[PaymentType] Set';
    constructor(public paymentType: PaymentType) {}
  }
}
